// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"PublicLayout_mainContainer__2DVXQ","mainContent":"PublicLayout_mainContent__3xpY0","pageContent":"PublicLayout_pageContent__1_RO7"};